import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import TouchSensitiveHide from '../TouchSensitiveHide';
import { isiPhoneBrowser } from '../../GlobalFunc';
import styles from './BottomSheet.module.css';

const viewport = window.visualViewport;
const initialViewportHeight = viewport.height;
export default function BottomSheet({
    isOpen,
    onClose,
    children,
    title,
    showCloseButton = true,
    backDropClassName = '',
    className = '',
    footer,
    setShadow,
    setHasScroll,
    setCanScrollWidth,
    bodyOverflowHidden = true,
    useSafeAreaPaddingBottom = false,
    adjustForKeyboard = false,
    isFocus,
    titleTouchSensitiveHide = {}
}) {
    const scrollContainerRef = useRef(null);
    const IsiPhoneBrowser = isiPhoneBrowser();
    useLayoutEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        const handleScroll = () => {
            if (scrollContainerRef.current) {
                const scrollLeftValue = scrollContainerRef.current.scrollLeft;
                setShadow?.(scrollLeftValue > 0);
            }
        };
        const windowScroll = () => {
            if (scrollContainerRef.current) {
                setHasScroll?.(scrollContainerRef.current.scrollWidth > scrollContainerRef.current.clientWidth);
                setCanScrollWidth?.(scrollContainerRef.current.scrollWidth - scrollContainerRef.current.clientWidth)
            }
        };
        if (isOpen && scrollContainer && setShadow) {
            scrollContainer.addEventListener('scroll', handleScroll);
            window.addEventListener('resize',windowScroll)
            windowScroll()
            return () => {
                scrollContainer.removeEventListener('scroll', handleScroll);
                window.removeEventListener('resize', windowScroll);
            }
        }
    }, [isOpen]);

    const [containerStyle, setContainerStyle] = useState({});

    const requestAnimationFrameRef = useRef(null);
    const setTimeoutRef = useRef(null);
    // useEffect(() => {
    //     // 仅在客户端执行
    //     if (typeof window === 'undefined' || !window.visualViewport || !IsiPhoneBrowser || !adjustForKeyboard) return;
    //     // 设置初始样式
    //     const updateContainerStyle = () => {
    //         // 计算键盘是否弹出
    //         const heightDiff = initialViewportHeight - viewport.height;

    //         const isKeyboardOpen = heightDiff > 150; // 阈值为100px

    //         if (isKeyboardOpen) {
    //             // 键盘弹出时，调整底部位置
    //             setContainerStyle({
    //                 transform: `translateY(-${heightDiff}px)`
    //             });
    //         } else {
    //             //     // 键盘收起时，使用默认样式
    //             setContainerStyle({});
    //         }
    //         // requestAnimationFrameRef.current = requestAnimationFrame(updateContainerStyle);
    //     };

    //     // 初始化样式
    //     // updateContainerStyle();

    //     // 监听 visualViewport 的 resize 事件
    //     const handleResize = () => {
    //         // 延迟执行以确保获取到正确的值
    //         if (setTimeoutRef.current) {
    //             clearTimeout(setTimeoutRef.current);
    //         }
    //         setTimeoutRef.current = setTimeout(updateContainerStyle, 500);
    //     };

    //     viewport.addEventListener('resize', handleResize);

    //     // if (requestAnimationFrameRef.current) {
    //     //     cancelAnimationFrame(requestAnimationFrameRef.current);
    //     // }
    //     // updateContainerStyle();
    //     // setTimeout(() => {
    //     //     cancelAnimationFrame(requestAnimationFrameRef.current);
    //     // }, 600);

    //     // 清理事件监听器
    //     return () => {
    //         viewport.removeEventListener('resize', handleResize);
    //         // cancelAnimationFrame(requestAnimationFrameRef.current);
    //     };
    // }, [adjustForKeyboard, IsiPhoneBrowser]);

    // 防止背景滚动和键盘支持
    useEffect(() => {
        if (isOpen && bodyOverflowHidden) {
            // 保存当前滚动位置
            const scrollY = window.scrollY;

            // 禁止滚动
            document.body.style.position = 'fixed';
            // document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';

            // 键盘事件处理
            // const handleKeyDown = (e) => {
            //     if (e.key === 'Escape') {
            //         onClose();
            //     }
            // };

            // document.addEventListener('keydown', handleKeyDown);

            return () => {
                // 恢复滚动
                document.body.style.position = '';
                document.body.style.top = '';
                document.body.style.width = '';
                document.body.style.overflow = '';
                // window.scrollTo({
                //     top: scrollY,
                //     left: 0,
                //     behavior: 'instant'
                // });

                // 移除键盘事件监听
                // document.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [isOpen, bodyOverflowHidden]);

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const handleClose = () => {
        onClose();
    };

    // 阻止事件冒泡，防止点击内容区域时关闭弹出层
    const handleContentClick = (e) => {
        e.stopPropagation();
    };

    if (!isOpen) {
        return null;
    }

    return (
        <div
            className={`ui-bottomSheet-backdrop ${backDropClassName} ${styles.backdrop} ${isOpen ? styles.backdropVisible : ''}`}
            onClick={handleBackdropClick}
            style={{bottom: useSafeAreaPaddingBottom ? 0 : undefined}}
        >
            <div
                style={{paddingBottom: useSafeAreaPaddingBottom ? 'env(safe-area-inset-bottom, 0)' : undefined}}
                className={`ui-bottomSheet ${className} ${styles.bottomSheet} ${
                    isOpen ? styles.bottomSheetOpen : styles.bottomSheetClosed
                }`}
                onClick={handleContentClick}
            >
                {/* 头部 */}
                {(showCloseButton || title) &&
                    ([undefined, true].includes(titleTouchSensitiveHide?.show) || titleTouchSensitiveHide.disable) && (
                        <TouchSensitiveHide
                            {...{ ...titleTouchSensitiveHide, direction: 'opacity' }}
                            className={`ui-bottomSheet-header ${styles.header}`}
                        >
                            <h3 className={`ui-bottomSheet-header-title ${styles.title}`}>{title}</h3>
                            {showCloseButton && (
                                <div
                                    className={`ui-bottomSheet-header-closeButton ${styles.closeButton}`}
                                    onClick={handleClose}
                                    aria-label="close"
                                ></div>
                            )}
                        </TouchSensitiveHide>
                    )}
                {/* 内容区域 */}
                <div ref={scrollContainerRef} className={`ui-bottomSheet-content ${styles.content}`}>
                    {children}
                </div>

                {footer && <div className={`ui-bottomSheet-footer ${styles.footer}`}>{footer}</div>}
            </div>
        </div>
    );
}
